module.exports = __webpack_public_path__ + "static/media/patrick.34add815.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patrick.png
// module id = 50
// module chunks = 0